// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expandable-item .expandable-item-sub {
  display: flex;
  flex-flow: column;
  gap: 2rem;
  height: 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}
.expandable-item .expandable-item-sub a {
  font-size: 14px;
}
.expandable-item .expandable-item-sub.expanded {
  height: auto;
  padding-top: 2.5rem;
  padding-left: 6rem;
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Navigations/Sidebar/ExpandableItem/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAGI;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AADN","sourcesContent":[".expandable-item {\n  .expandable-item-sub {\n    display: flex;\n    flex-flow: column;\n    gap: 2rem;\n    height: 0;\n    overflow: hidden;\n    transition: all 0.3s ease-in-out;\n\n    a {\n      font-size: 14px;\n    }\n\n    &.expanded {\n      height: auto;\n      padding-top: 2.5rem;\n      padding-left: 6rem;\n      overflow: visible;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
